import React from 'react';
import { Facebook, Instagram, Mail } from 'lucide-react';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-earth text-cal py-16">
      <div className="editorial-container">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <button
              onClick={scrollToTop}
              className="display-heading text-3xl text-cal hover:text-ochre-light transition-colors mb-4"
            >
              El Cercado
            </button>
            <p className="text-sm text-cal/70 leading-relaxed mb-4">
              Isla de Margarita · Venezuela
            </p>
            <p className="text-sm text-cal/60 leading-relaxed">
              Cinco siglos de alfarería viva en la Isla de Margarita.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-medium text-cal mb-4 uppercase tracking-wider text-sm">
              Navegación
            </h3>
            <nav className="space-y-2">
              <button
                onClick={() => document.getElementById('el-cercado')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                El Pueblo
              </button>
              <button
                onClick={() => document.getElementById('el-oficio')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                El Oficio
              </button>
              <button
                onClick={() => document.getElementById('los-artesanos')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                Los Artesanos
              </button>
              <button
                onClick={() => document.getElementById('las-piezas')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                Las Piezas
              </button>
              <button
                onClick={() => document.getElementById('visitas-clases')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                Experiencias
              </button>
              <button
                onClick={() => document.getElementById('visita')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-cal/70 hover:text-ochre-light transition-colors"
              >
                Contacto
              </button>
            </nav>
          </div>

          {/* Social & Contact */}
          <div>
            <h3 className="font-medium text-cal mb-4 uppercase tracking-wider text-sm">
              Conecta con nosotros
            </h3>
            <div className="flex gap-4 mb-6">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-cal/10 hover:bg-siena flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-cal/10 hover:bg-siena flex items-center justify-center transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="mailto:info@elcercado.com"
                className="w-10 h-10 rounded-full bg-cal/10 hover:bg-siena flex items-center justify-center transition-all duration-300"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-sm text-cal/60 leading-relaxed">
              Fundación ArtesanoGroup
              <br />
              Candidatura UNESCO 2015
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-cal/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-cal/60">
              © {new Date().getFullYear()} El Cercado. Isla de Margarita, Venezuela.
            </p>
            <p className="text-xs text-cal/50">
              Diseño web con respeto al patrimonio cultural
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
